import { createSlice } from "@reduxjs/toolkit";
import types from "../../Actions/AlliedForcesApplication/types";
import GlobalTypes from "../../Actions/types";
import { AlliedForcesApplicationMetadata } from "./AlliedForcesApplicationMetadata";
import { AlliedForcesProfileMetadata } from "./AlliedForcesProfileMetadata";
import { AlliedForcesPreSurveyMetadata } from "./AlliedForcesPreSurveyMetadata";
import { AlliedForcesPostSurveyMetadata } from "./AlliedForcesPostSurveyMetadata";
import * as utils from "../../Utils/reducerUtils";

const initialState = {
    showErrors: false,
    applicationMetadata: AlliedForcesApplicationMetadata,
    profileMetadata: AlliedForcesProfileMetadata,
    preSurveyMetadata: AlliedForcesPreSurveyMetadata,
    postSurveyMetadata: AlliedForcesPostSurveyMetadata,
    initialized: false,
    submittingApplication: false,
    saving: false,
    application: {},
    applicationIsComplete: false,
    interests: [],
    fetchingInterests: false,
    alliedForcesApplication: {},
    alliedForcesApplicationIsComplete: false,
};

const alliedForcesSlice = createSlice({
  name: "alliedForcesApplication",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(types.SUBMITTED_ALLIED_FORCES_APPLICATION, (state) => {
      state.submittingApplication = false;
    });
    builder.addCase(GlobalTypes.LOGOUT, () => ({
      showErrors: false,
      applicationMetadata: AlliedForcesApplicationMetadata,
      profileMetadata: AlliedForcesProfileMetadata,
      preSurveyMetadata: AlliedForcesPreSurveyMetadata,
      postSurveyMetadata: AlliedForcesPostSurveyMetadata,
      initialized: false,
      submittingApplication: false,
      saving: false,
      application: {},
      applicationIsComplete: false,
      interests: [],
      fetchingInterests: false,
      alliedForcesApplication: {},
      alliedForcesApplicationIsComplete: false,
    }));
    builder.addCase(types.TOGGLE_ALLIED_FORCES_UNFILLED, (state) => {
      state.showErrors = true;
      state.applicationMetadata = state.applicationMetadata.map((input) => ({
        ...input,
        steps: input.steps.map((step) =>
          !step.filled ? { ...step, unseenError: true } : step
        ),
      }));
      state.profileMetadata = state.profileMetadata.map((input) => ({
        ...input,
        steps: input.steps.map((step) =>
          !step.filled ? { ...step, unseenError: true } : step
        ),
      }));
    });
    builder.addCase(types.SUBMIT_ALLIED_FORCES_APPLICATION, (state) => {
      state.showErrors = false;
      state.submittingApplication = true;
    });
    builder.addCase(types.INIT_ALLIED_FORCES_APPLICATION, (state, action) => {
      const updatedMetaData = utils.processNavOptionsForApplication(
        action.data.application,
        state.applicationMetadata
      );
      const updatedProfileMetaData = utils.processNavOptionsforProfile(
        action.data.application,
        state.profileMetadata
      );
      state.application = action.data.application;
      state.applicationMetadata = updatedMetaData;
      state.applicationIsComplete = utils.allFormsFilled(updatedMetaData);
      state.profileIsComplete = utils.allFormsFilled(updatedProfileMetaData);
      state.initialized = true;
      state.profileMetadata = updatedProfileMetaData;
      state.userWillReLocate =
        action.data.application.address &&
        action.data.application.address.willLocate === "Yes";
    });
    builder.addCase(types.FETCHED_ALLIED_FORCES_APPLICATION, (state, action) => {
      const updatedAlliedForcesApplicationMetaData =
        utils.processNavOptionsForApplication(
          action.data.application,
          state.applicationMetadata
        );
      const updatedAlliedForcesProfileData = utils.processNavOptionsforProfile(
        action.data.application,
        state.profileMetadata
      );
      state.alliedForcesApplication = action.data.application;
      state.applicationMetadata = updatedAlliedForcesApplicationMetaData;
      state.saving = false;
      state.alliedForcesApplicationIsComplete = utils.allFormsFilled(
        updatedAlliedForcesApplicationMetaData
      );
      state.profileIsComplete = utils.allFormsFilled(updatedAlliedForcesProfileData);
      state.profileMetadata = updatedAlliedForcesProfileData;
      state.currentInputData = null;
      state.userWillReLocate =
        action.data.application.address &&
        action.data.application.address.willLocate === "Yes";
    });
    builder.addCase(types.SET_ALLIED_FORCES_APPLICATION_INPUT_DATA, (state, action) => {
      state.currentInputData = action.data.inputData;
    });
    builder.addCase(GlobalTypes.LOGIN, (state) => {
      state.initialized = false;
      state.showErrors = false;
    });
    builder.addCase(types.EDIT_ALLIED_FORCES_APPLICATION, (state) => {
      state.currentInputData = null;
      state.saving = false;
    });
    builder.addCase(types.SAVING_ALLIED_FORCES_APPLICATION, (state) => {
      state.saving = true;
    });
    builder.addCase(types.UPDATE_INTERESTS, (state, action) => {
      state.interests = action.data.interests;
    });
    builder.addCase(types.TOGGLE_FETCHING_INTERESTS, (state, action) => {
      state.fetchingInterests = action.data.toggle;
    });
  },
});

export default alliedForcesSlice.reducer;
